import React from 'react'
import styled from 'styled-components'
import Collapsible from 'react-collapsible'
import PropTypes from 'prop-types'
import Caret from 'images/icons/Caret'

const StyledAccordion = styled.div`
  color: #384047;
`

const TriggerWrapper = styled.div`
  position: relative;
`

const CaretWrapper = styled.span`
  position: absolute;
  top: ${(props) => (props.position === 'top' ? '12px' : 'calc(50% - 8px)')};
  right: 16px;
  transition: all 200ms ease-in-out;
  line-height: 8px;

  .Collapsible__trigger--is-open & {
    transform: rotate(-180deg);
    color: green;
  }
`

function Accordion(props) {
  const { children, trigger, caretPosition, caretTheme, ...remainingProps } = props
  return (
    <StyledAccordion>
      <Collapsible
        trigger={
          <TriggerWrapper>
            {trigger}
            <CaretWrapper position={caretPosition}>
              <Caret direction="down" theme={caretTheme} />
            </CaretWrapper>
          </TriggerWrapper>
        }
        transitionTime={200}
        easing="ease-in-out"
        triggerOpenedClassName="Collapsible__trigger--is-open"
        {...remainingProps}
      >
        {children}
      </Collapsible>
    </StyledAccordion>
  )
}

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  trigger: PropTypes.node.isRequired,
  caretPosition: PropTypes.string.isRequired,
  caretTheme: PropTypes.string,
}
Accordion.defaultProps = {
  caretPosition: 'top',
}

export default Accordion



// WEBPACK FOOTER //
// ./src/molecules/Accordion/Accordion.js